import React from 'react';
import { View, Text, StyleSheet, Platform } from "react-native";

import * as d3 from '../../../d3/d3.v7';
import chroma from "../../../d3/chroma";
import { sankey, sankeyLinkHorizontal } from "../../../d3/d3-sankey";
//import { sankeyCircular } from "../../../d3/d3-sankey-circular";

class SankeyChart extends React.Component {

    constructor(props) {
        super(props);
    }

    render() {
        if (!this.props.data) return (<></>);

        var margin = { top: 10, right: 0, bottom: 10, left: 0 };
        var format = (d) => formatNumber(d);
        var formatNumber = d3.format(",.0f"); // zero decimal places

        const width = this.props.width, height = this.props.height;
        var sk = sankey()
            .size([width, height])
            .nodeWidth(15)
            .nodePadding(10);
        const { nodes, links, link } = sk.extent([[1, 1], [width - 1, height - 5]])(this.props.data);

        let mmax = 0;
        links.forEach((link) => { if (link.width > mmax) mmax = link.width; })
        const heatmap = chroma.scale(["#fff7ec", "#cf0000"]).domain([0, mmax]);
        const color = chroma.scale("Set3").classes(nodes.length);
        const colorScale = d3
            .scaleLinear()
            .domain([0, nodes.length])
            .range([0, 1]);

        const Links = links.map((link, i) => {
          const width = link.width;
          const c = heatmap(width).hex();
          const p = sankeyLinkHorizontal();
          const opacity = 0.5;

          return (
            <g>
              <path key={'skp' + i} fill={"none"} strokeOpacity={opacity} stroke={c} onClick={()=>{}} d={p(link)} strokeWidth={Math.max(1, width)}>
                <title>{link.source.name + " → " + link.target.name + "\n Weight: " + format(link.value)}</title>
              </path>
            </g>
          );
        });

        const Nodes = nodes.map((node, i) => {
          const x = node.x0;
          const y = node.y0;
          const ny = node.y1 - node.y0;
          const c = color(colorScale(i)).hex();
          const cText = "#101010";
          return (
            <g key={'skn' + i} onClick={()=>{}} transform={"translate(" + x + "," + y + ")"}>
              <rect height={ny} width={sk.nodeWidth()} fill={c}>
                <title>{node.name + "\n" + format(node.value)}</title>
              </rect>
              { (x >= width / 2) ?
                <text fontSize={8} fontFamily={"Montserrat"} fill={cText} x={-6} y={ny / 2} dy={".35em"} textAnchor={"end"} >{node.name}</text> :
                <text fontSize={8} fontFamily={"Montserrat"} fill={cText} x={6 + sk.nodeWidth()} y={ny / 2} dy={".35em"} textAnchor={"start"} >{node.name}</text>
              }
            </g>
          );
        });

        return (<>
            <svg width={width + margin.left + margin.right} height={height + margin.top + margin.bottom}>
                <g transform={"translate(" + margin.left + "," + margin.top + ")"}>
                    {Links}
                    {Nodes}
                </g>
            </svg>
        </>);
    }
}

export default SankeyChart;

